import { render, staticRenderFns } from "./c_auxiliary_box.vue?vue&type=template&id=6e9f0630&scoped=true"
import script from "./c_auxiliary_box.vue?vue&type=script&lang=js"
export * from "./c_auxiliary_box.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9f0630",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e9f0630')) {
      api.createRecord('6e9f0630', component.options)
    } else {
      api.reload('6e9f0630', component.options)
    }
    module.hot.accept("./c_auxiliary_box.vue?vue&type=template&id=6e9f0630&scoped=true", function () {
      api.rerender('6e9f0630', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobileConfig/c_auxiliary_box.vue"
export default component.exports